// // import {
// //   Drawer,
// //   DrawerBody,
// //   DrawerFooter,
// //   DrawerHeader,
// //   DrawerOverlay,
// //   DrawerContent,
// //   DrawerCloseButton,
// //   Checkbox,
// //   Input,
// // } from "@chakra-ui/react";
// // import Select from "react-select";
// // import { useDispatch, useSelector } from "react-redux";
// // import { toast } from "react-toastify";
// // import { useState } from "react";
// // import {
// //   stringConditions,
// //   dropdownConditions,
// // } from "../../../AdminPannel/utils/SearchPickList";

// // import { getRawMaterialList } from "../../../../redux/reduxApi/admin/RawMaterialApi";
// // import { setFilteredStatus } from "../../../../redux/reduxSlice/admin/RawMaterialSlice";
// // import ProgressBar from "../../utils/progressBar/ProgressBar";

// // export default function RawMaterialSearchDrawer({
// //   isSearchDrawerOpen,
// //   closeDrawer,
// //   setRecordCount,
// // }) 
// // {
// //   const dispatch = useDispatch();
// //   const [showProgressBar, setShowProgressBar] = useState(false);
// //   const colourList = useSelector((state) => state.colour.colour);
// // const [colourLoading, setColourLoading] = useState(false);
// //   /* -------------------- FILTER CONFIG -------------------- */
// //   const filtersConfig = [
// //     { key: "productName", label: "Material Name", optionsType: "string" },
// //     // { key: "materialType", label: "Material Type", optionsType: "dropdown" },
// //     { key: "sku", label: "SKU", optionsType: "string" },
// //     { key: "purchasePrice", label: "Purchase Price", optionsType: "number" },
// //     { key: "hsnCode", label: "HSN Code", optionsType: "string" },
// //     { key: "tax", label: "Tax", optionsType: "dropdown" },
// //     { key: "colour", label: "Colour", optionsType: "dropdown" },
// //     // { key: "vendor", label: "Vendor", optionsType: "string" },
// //   ];

// //   // Material Type Options
// //   const materialTypeOptions = [
// //     { label: "Fabric", value: "fabric" },
// //     { label: "Yarn", value: "yarn" },
// //     { label: "Chemical", value: "chemical" },
// //     { label: "Packaging Material", value: "packaging" },
// //     { label: "Hardware", value: "hardware" },
// //   ];

// //   // Tax Options
// //   const taxOptions = [
// //     { label: "5%", value: "5%" },
// //     { label: "12%", value: "12%" },
// //     { label: "18%", value: "18%" },
// //     { label: "28%", value: "28%" },
// //   ];

// //   // Colour Options
// //   // const colourOptions = [
// //   //   { label: "Red", value: "Red" },
// //   //   { label: "Green", value: "Green" },
// //   //   { label: "Blue", value: "Blue" },
// //   //   { label: "Yellow", value: "Yellow" },
// //   //   { label: "Purple", value: "Purple" },
// //   //   { label: "Orange", value: "Orange" },
// //   //   { label: "Black", value: "Black" },
// //   //   { label: "White", value: "White" },
// //   // ];

// // const [colourOptions, setColourOptions] = useState([]);
// //   const [filters, setFilters] = useState(
// //     filtersConfig.reduce((acc, f) => {
// //       acc[f.key] = {
// //         checked: false,
// //         condition: { label: "Is", value: "is" },
// //         showInput: false,
// //         value: "",
// //       };
// //       return acc;
// //     }, {})
// //   );
// //   useEffect(() => {
// //   if (colourList && colourList.length > 0) {
// //     const options = colourList.map(colour => ({
// //       value: colour.ROWID,
// //       label: colour.colour
// //     }));
// //     setColourOptions(options);
// //   }
// // }, [colourList]);
// // useEffect(() => {
// //   setColourLoading(true);
// //   dispatch(getColoursList())
// //     .finally(() => setColourLoading(false));
// // }, [dispatch]);


// //   /* -------------------- HANDLERS -------------------- */

// //   const handleCheckboxChange = (key) => (e) => {
// //     const checked = e.target.checked;

// //     setFilters((prev) => ({
// //       ...prev,
// //       [key]: {
// //         ...prev[key],
// //         checked,
// //         condition: { label: "Is", value: "is" },
// //         showInput: checked,
// //         value: "",
// //       },
// //     }));
// //   };

// //   const handleConditionChange = (key) => (selected) => {
// //     const hideInputFor = ["is-empty", "is-not-empty"];

// //     setFilters((prev) => ({
// //       ...prev,
// //       [key]: {
// //         ...prev[key],
// //         condition: selected,
// //         showInput: !hideInputFor.includes(selected.value),
// //       },
// //     }));
// //   };

// // const handleValueChange = (key) => (value) => {
// //   setFilters((prev) => ({
// //     ...prev,
// //     [key]: { ...prev[key], value }, // value will be ROWID
// //   }));
// // };

// //   const getOptions = (type) => {
// //     switch (type) {
// //       case "materialType":
// //         return materialTypeOptions;
// //       case "tax":
// //         return taxOptions;
// //       case "colour":
// //         return colourOptions;
// //       default:
// //         return [];
// //     }
// //   };

// //   /* -------------------- SEARCH -------------------- */

// //   // const handleSearch = async () => {

// //   //   const search = [];

// //   //   filtersConfig.forEach(({ key }) => {
// //   //     const current = filters[key];

// //   //     if (current.checked) {
// //   //       let value = current.value;
// //   //       let operation = current.condition?.value || "is";

// //   //       if (operation === "is-empty" || operation === "is-not-empty") {
// //   //         value = "";
// //   //       }

// //   //       const shouldAdd =
// //   //         operation === "is-empty" ||
// //   //         operation === "is-not-empty" ||
// //   //         (value !== undefined && value !== null && value !== "");

// //   //       if (shouldAdd) {
// //   //         search.push({
// //   //           field: key,
// //   //           operation,
// //   //           value,
// //   //         });
// //   //       }
// //   //     }
// //   //   });

// //   //   if (search.length === 0) {
// //   //     toast.warning("Please select at least one filter");
// //   //     return;
// //   //   }

// //   //   setShowProgressBar(true);

// //   //   try {
// //   //     const query = {
// //   //       page: "1",
// //   //       size: "100",
// //   //       search,
// //   //     };

// //   //     sessionStorage.setItem("rawMaterialSearchQuery", JSON.stringify(query));

// //   //     const response = await dispatch(getRawMaterialList(query));

// //   //     setShowProgressBar(false);

// //   //     if (
// //   //       response?.error?.code === "ERR_BAD_REQUEST" ||
// //   //       response?.error?.message?.includes("404")
// //   //     ) {
// //   //       toast.warning("No records found!");
// //   //     } else if (response?.payload?.success) {
// //   //       const data = response.payload?.data || [];

// //   //       if (data.length > 0) {
// //   //         setRecordCount && setRecordCount(data.length);
// //   //         dispatch(setFilteredStatus(true));
// //   //         toast.success("Raw materials filtered successfully!");
// //   //       } else {
// //   //         toast.warning("No records found!");
// //   //         dispatch(setFilteredStatus(false));
// //   //       }

// //   //       closeDrawer();
// //   //     } else {
// //   //       toast.error("Error in filtering raw materials");
// //   //     }
// //   //   } catch (err) {
// //   //     setShowProgressBar(false);
// //   //     toast.error("Something went wrong");
// //   //     console.error("Search error:", err);
// //   //   }
// //   // };

// //   // RawMaterialSearchDrawer.jsx - handleSearch mein replace karo

// // //  // RawMaterialSearchDrawer.jsx - Updated handleSearch function

// // const handleSearch = async () => {
// //   const search = [];

// //   filtersConfig.forEach(({ key }) => {
// //     const current = filters[key];
// //     if (current.checked) {
// //       let value = current.value;
// //       let operation = current.condition?.value || "is";
// //       if (operation === "is-empty" || operation === "is-not-empty") value = "";

// //       const shouldAdd =
// //         operation === "is-empty" ||
// //         operation === "is-not-empty" ||
// //         (value !== undefined && value !== null && value !== "");

// //       if (shouldAdd) {
// //         search.push({ field: key, operation, value });
// //       }
// //     }
// //   });

// //   if (search.length === 0) {
// //     toast.warning("Please select at least one filter");
// //     return;
// //   }

// //   // Show progress bar while fetching
// //   setShowProgressBar(true);

// //   try {
// //     const query = { page: "1", size: "100", search };
    
// //     // Store query in sessionStorage
// //     sessionStorage.setItem("rawMaterialSearchQuery", JSON.stringify(query));
    
// //     // Fetch filtered data
// //     const response = await dispatch(getRawMaterialList(query));
    
// //     // Hide progress bar
// //     setShowProgressBar(false);

// //     // Handle response
// //     if (response?.error?.code === "ERR_BAD_REQUEST" || 
// //         response?.error?.message?.includes("404")) {
// //       toast.warning("No records found!");
// //       dispatch(setFilteredStatus(false));
// //     } else if (response?.payload?.success) {
// //       const data = response.payload?.data || [];
      
// //       if (data.length > 0) {
// //         // Success - records found
// //         setRecordCount && setRecordCount(data.length);
// //         dispatch(setFilteredStatus(true));
// //         toast.success("Raw materials filtered successfully!");
// //         closeDrawer();
// //       } else {
// //         // No records found
// //         toast.warning("No records found!");
// //         dispatch(setFilteredStatus(false));
// //         // Optionally close drawer even if no records
// //         closeDrawer();
// //       }
// //     } else {
// //       toast.error("Error in filtering raw materials");
// //       dispatch(setFilteredStatus(false));
// //     }
// //   } catch (err) {
// //     setShowProgressBar(false);
// //     toast.error("Something went wrong");
// //     console.error("Search error:", err);
// //     dispatch(setFilteredStatus(false));
// //   }
// // };

// //   /* -------------------- RESET -------------------- */

// //   const handleReset = () => {
// //     setFilters(
// //       filtersConfig.reduce((acc, f) => {
// //         acc[f.key] = {
// //           checked: false,
// //           condition: { label: "Is", value: "is" },
// //           showInput: false,
// //           value: "",
// //         };
// //         return acc;
// //       }, {})
// //     );
// //   };

// //   const handleOnClose = () => {
// //     handleReset();
// //     closeDrawer();
// //   };

// //   /* -------------------- UI -------------------- */

// //   return (
// //     <Drawer
// //       isOpen={isSearchDrawerOpen}
// //       placement="right"
// //       size="xs"
// //       onClose={handleOnClose}
// //     >
// //       <DrawerOverlay />
// //       <DrawerContent>
// //         <DrawerCloseButton />

// //         <DrawerHeader>
// //           <div className="d-flex gap-4">
// //             <span>Search Raw Material</span>
// //             <button className="reset-btn" onClick={handleReset}>
// //               Reset
// //             </button>
// //           </div>
// //         </DrawerHeader>

// //         <DrawerBody>
// //           {showProgressBar && <ProgressBar colorScheme="pink" />}

// //           {filtersConfig.map(({ key, label, optionsType }) => {
// //             const current = filters[key];

// //             return (
// //               <div className="mt-3" key={key}>
// //                 <Checkbox
// //                   isChecked={current.checked}
// //                   onChange={handleCheckboxChange(key)}
// //                 >
// //                   {label}
// //                 </Checkbox>

// //                 {current.checked && (
// //                   <>
// //                     {/* Condition */}
// //                     <Select
// //                       className="mt-2"
// //                       options={
// //                         optionsType === "dropdown"
// //                           ? dropdownConditions
// //                           : stringConditions
// //                       }
// //                       value={current.condition}
// //                       onChange={handleConditionChange(key)}
// //                     />

// //                     {/* Value */}
// //                     {current.showInput && (
// //                       <>
// //                         {optionsType === "dropdown" ? (
// //                           <Select
// //                             isClearable
// //                             className="mt-2"
// //                             options={getOptions(key)}
// //                             placeholder={`Select ${label}`}
// //                             onChange={(opt) =>
// //                               handleValueChange(key)(opt ? opt.value : "")
// //                             }
// //                             value={
// //                               getOptions(key).find(
// //                                 (o) => o.value === current.value
// //                               ) || null
// //                             }
// //                           />
// //                         ) : (
// //                           <Input
// //                             className="mt-2"
// //                             type={
// //                               optionsType === "number" ? "number" : "text"
// //                             }
// //                             placeholder={`Enter ${label}`}
// //                             value={current.value || ""}
// //                             onChange={(e) =>
// //                               handleValueChange(key)(e.target.value)
// //                             }
// //                           />
// //                         )}
// //                       </>
// //                     )}
// //                   </>
// //                 )}
// //               </div>
// //             );
// //           })}
// //         </DrawerBody>

// //         <center>
// //           <DrawerFooter style={{ display: "inline-block" }}>
// //             <div className="d-flex gap-3">
// //               <button className="cancel-button" onClick={handleOnClose}>
// //                 Cancel
// //               </button>
// //               <button className="main-btn" onClick={handleSearch}>
// //                 <span className="inner-content">Search</span>
// //               </button>
// //             </div>
// //           </DrawerFooter>
// //         </center>
// //       </DrawerContent>
// //     </Drawer>
// //   );
// // }

// import {
//   Drawer,
//   DrawerBody,
//   DrawerFooter,
//   DrawerHeader,
//   DrawerOverlay,
//   DrawerContent,
//   DrawerCloseButton,
//   Checkbox,
//   Input,
// } from "@chakra-ui/react";
// import Select from "react-select";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { useState, useEffect } from "react"; // Added useEffect
// import {
//   stringConditions,
//   dropdownConditions,
//   numberComponent,
// } from "../../../AdminPannel/utils/SearchPickList";

// import { getRawMaterialList } from "../../../../redux/reduxApi/admin/RawMaterialApi";
// import { setFilteredStatus } from "../../../../redux/reduxSlice/admin/RawMaterialSlice";
// import ProgressBar from "../../utils/progressBar/ProgressBar";
// import { getColoursList } from "../../../../redux/reduxApi/admin/ColourReduxApi"; // Added import

// export default function RawMaterialSearchDrawer({
//   isSearchDrawerOpen,
//   closeDrawer,
//   setRecordCount,
// }) {
//   const dispatch = useDispatch();
//   const [showProgressBar, setShowProgressBar] = useState(false);
  
//   // Get colours from Redux store
//   const colourList = useSelector((state) => state.colour.colour);
//   const [colourOptions, setColourOptions] = useState([]);
//   const [colourLoading, setColourLoading] = useState(false);

//   /* -------------------- FILTER CONFIG -------------------- */
//   const filtersConfig = [
//     { key: "productName", label: "Material Name", optionsType: "string" },
//     { key: "materialType", label: "Material Type", optionsType: "dropdown" },
//     { key: "sku", label: "SKU", optionsType: "string" },
//     { key: "available", label: "Available Stock", optionsType: "number" },
//     { key: "purchasePrice", label: "Purchase Price", optionsType: "string" },
//     { key: "consumptionUnit", label: "Consumption Unit", optionsType: "dropdown" },
//     { key: "hsnCode", label: "HSN Code", optionsType: "string" },
//     { key: "tax", label: "Tax", optionsType: "dropdown" },
//     { key: "colour", label: "Colour", optionsType: "dropdown" },
//   ];

//   // Material Type Options
//   const materialTypeOptions = [
//     { label: "Fabric", value: "fabric" },
//     { label: "Yarn", value: "yarn" },
//     { label: "Chemical", value: "chemical" },
//     { label: "Packaging Material", value: "packaging" },
//     { label: "Hardware", value: "hardware" },
//   ];

//   // Tax Options
//   const taxOptions = [
//     { label: "5%", value: "5%" },
//     { label: "12%", value: "12%" },
//     { label: "18%", value: "18%" },
//     { label: "28%", value: "28%" },
//   ];

//   /* -------------------- STATE -------------------- */
//   const [filters, setFilters] = useState(
//     filtersConfig.reduce((acc, f) => {
//       acc[f.key] = {
//         checked: false,
//         condition: { label: "Is", value: "is" },
//         showInput: false,
//         value: "",
//       };
//       return acc;
//     }, {})
//   );

//   /* -------------------- FETCH DYNAMIC COLOURS -------------------- */
  
//   // Fetch colours on component mount
//   useEffect(() => {
//     setColourLoading(true);
//     dispatch(getColoursList())
//       .finally(() => setColourLoading(false));
//   }, [dispatch]);

//   // Update colour options when colourList changes
//   useEffect(() => {
//     if (colourList && colourList.length > 0) {
//       const options = colourList.map(colour => ({
//         value: colour.ROWID,
//         label: colour.colour
//       }));
//       setColourOptions(options);
//     } else {
//       setColourOptions([]); // Set empty array if no colours
//     }
//   }, [colourList]);

//   /* -------------------- HANDLERS -------------------- */

//   const handleCheckboxChange = (key) => (e) => {
//     const checked = e.target.checked;

//     setFilters((prev) => ({
//       ...prev,
//       [key]: {
//         ...prev[key],
//         checked,
//         condition: { label: "Is", value: "is" },
//         showInput: checked,
//         value: "",
//       },
//     }));
//   };

//   const handleConditionChange = (key) => (selected) => {
//     const hideInputFor = ["is-empty", "is-not-empty"];

//     setFilters((prev) => ({
//       ...prev,
//       [key]: {
//         ...prev[key],
//         condition: selected,
//         showInput: !hideInputFor.includes(selected.value),
//       },
//     }));
//   };

//   const handleValueChange = (key) => (value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [key]: { ...prev[key], value },
//     }));
//   };

//   const getOptions = (type) => {
//     switch (type) {
//       case "materialType":
//         return materialTypeOptions;
//       case "tax":
//         return taxOptions;
//       case "colour":
//         return colourOptions; // Now dynamic from Redux
//       default:
//         return [];
//     }
//   };

//   /* -------------------- SEARCH -------------------- */

//   const handleSearch = async () => {
//     const search = [];

//     filtersConfig.forEach(({ key }) => {
//       const current = filters[key];
//       if (current.checked) {
//         let value = current.value;
//         let operation = current.condition?.value || "is";
//         if (operation === "is-empty" || operation === "is-not-empty") value = "";

//         const shouldAdd =
//           operation === "is-empty" ||
//           operation === "is-not-empty" ||
//           (value !== undefined && value !== null && value !== "");

//         if (shouldAdd) {
//           search.push({ field: key, operation, value });
//         }
//       }
//     });

//     if (search.length === 0) {
//       toast.warning("Please select at least one filter");
//       return;
//     }

//     setShowProgressBar(true);

//     try {
//       const query = { page: "1", size: "100", search };
      
//       sessionStorage.setItem("rawMaterialSearchQuery", JSON.stringify(query));
      
//       const response = await dispatch(getRawMaterialList(query));
      
//       setShowProgressBar(false);

//       if (response?.error?.code === "ERR_BAD_REQUEST" || 
//           response?.error?.message?.includes("404")) {
//         toast.warning("No records found!");
//         dispatch(setFilteredStatus(false));
//       } else if (response?.payload?.success) {
//         const data = response.payload?.data || [];
        
//         if (data.length > 0) {
//           setRecordCount && setRecordCount(data.length);
//           dispatch(setFilteredStatus(true));
//           toast.success("Raw materials filtered successfully!");
//           closeDrawer();
//         } else {
//           toast.warning("No records found!");
//           dispatch(setFilteredStatus(false));
//           closeDrawer();
//         }
//       } else {
//         toast.error("Error in filtering raw materials");
//         dispatch(setFilteredStatus(false));
//       }
//     } catch (err) {
//       setShowProgressBar(false);
//       toast.error("Something went wrong");
//       console.error("Search error:", err);
//       dispatch(setFilteredStatus(false));
//     }
//   };

//   /* -------------------- RESET -------------------- */

//   const handleReset = () => {
//     setFilters(
//       filtersConfig.reduce((acc, f) => {
//         acc[f.key] = {
//           checked: false,
//           condition: { label: "Is", value: "is" },
//           showInput: false,
//           value: "",
//         };
//         return acc;
//       }, {})
//     );
//   };

//   const handleOnClose = () => {
//     handleReset();
//     closeDrawer();
//   };

//   /* -------------------- UI -------------------- */

//   return (
//     <Drawer
//       isOpen={isSearchDrawerOpen}
//       placement="right"
//       size="xs"
//       onClose={handleOnClose}
//     >
//       <DrawerOverlay />
//       <DrawerContent>
//         <DrawerCloseButton />

//         <DrawerHeader>
//           <div className="d-flex gap-4">
//             <span>Search Raw Material</span>
//             <button className="reset-btn" onClick={handleReset}>
//               Reset
//             </button>
//           </div>
//         </DrawerHeader>

//         <DrawerBody>
//           {showProgressBar && <ProgressBar colorScheme="pink" />}

//           {filtersConfig.map(({ key, label, optionsType }) => {
//             const current = filters[key];

//             return (
//               <div className="mt-3" key={key}>
//                 <Checkbox
//                   isChecked={current.checked}
//                   onChange={handleCheckboxChange(key)}
//                 >
//                   {label}
//                 </Checkbox>

//                 {current.checked && (
//                   <>
//                     {/* Condition */}
//                     <Select
//                       className="mt-2"
//                       options={
//                         optionsType === "dropdown"
//                           ? dropdownConditions
//                           : stringConditions
//                       }
//                       value={current.condition}
//                       onChange={handleConditionChange(key)}
//                     />

//                     {/* Value */}
//                     {current.showInput && (
//                       <>
//                         {optionsType === "dropdown" ? (
//                           <Select
//                             isClearable
//                             className="mt-2"
//                             options={getOptions(key)}
//                             placeholder={`Select ${label}`}
//                             isLoading={key === "colour" && colourLoading}
//                             onChange={(opt) =>
//                               handleValueChange(key)(opt ? opt.value : "")
//                             }
//                             value={
//                               getOptions(key).find(
//                                 (o) => o.value === current.value
//                               ) || null
//                             }
//                           />
//                         ) : (
//                           <Input
//                             className="mt-2"
//                             type={
//                               optionsType === "number" ? "number" : "text"
//                             }
//                             placeholder={`Enter ${label}`}
//                             value={current.value || ""}
//                             onChange={(e) =>
//                               handleValueChange(key)(e.target.value)
//                             }
//                           />
//                         )}
//                       </>
//                     )}
//                   </>
//                 )}
//               </div>
//             );
//           })}
//         </DrawerBody>

//         <center>
//           <DrawerFooter style={{ display: "inline-block" }}>
//             <div className="d-flex gap-3">
//               <button className="cancel-button" onClick={handleOnClose}>
//                 Cancel
//               </button>
//               <button className="main-btn" onClick={handleSearch}>
//                 <span className="inner-content">Search</span>
//               </button>
//             </div>
//           </DrawerFooter>
//         </center>
//       </DrawerContent>
//     </Drawer>
//   );
// }
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Checkbox,
  Input,
} from "@chakra-ui/react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import {
  stringConditions,
  dropdownConditions,
  numberComponent,
} from "../../../AdminPannel/utils/SearchPickList";

import { getRawMaterialList } from "../../../../redux/reduxApi/admin/RawMaterialApi";
import { setFilteredStatus } from "../../../../redux/reduxSlice/admin/RawMaterialSlice";
import ProgressBar from "../../utils/progressBar/ProgressBar";
import { getColoursList } from "../../../../redux/reduxApi/admin/ColourReduxApi";
import { getRawMaterialCollectionList } from "../../../../redux/reduxApi/admin/RawMaterialCollectionReduxApi";
import { taxOptions, rawMaterialUnitOptions } from "../../../AdminPannel/utils/SearchPickList";

export default function RawMaterialSearchDrawer({
  isSearchDrawerOpen,
  closeDrawer,
  setRecordCount,
}) {
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  
  // Get data from Redux store
  const colourList = useSelector((state) => state.colour.colour);
  const rawMaterialCollectionList = useSelector((state) => state.rawMaterialCollection.rawMaterialCollection);
  
  // State for dynamic options
  const [colourOptions, setColourOptions] = useState([]);
  const [materialTypeOptions, setMaterialTypeOptions] = useState([]);
  const [colourLoading, setColourLoading] = useState(false);
  const [materialTypeLoading, setMaterialTypeLoading] = useState(false);

  /* -------------------- FILTER CONFIG -------------------- */
  const filtersConfig = [
    { key: "productName", label: "Material Name", optionsType: "string" },
    { key: "materialType", label: "Material Type", optionsType: "dropdown" },
    { key: "sku", label: "SKU", optionsType: "string" },
    { key: "available", label: "Available Stock", optionsType: "number" },
    { key: "purchasePrice", label: "Purchase Price", optionsType: "st ring" },
    { key: "consumptionUnit", label: "Consumption Unit", optionsType: "dropdown" },
    { key: "hsnCode", label: "HSN Code", optionsType: "string" },
    { key: "tax", label: "Tax", optionsType: "dropdown" },
    { key: "colour", label: "Colour", optionsType: "dropdown" },
  ];

  /* -------------------- STATE -------------------- */
  const [filters, setFilters] = useState(
    filtersConfig.reduce((acc, f) => {
      acc[f.key] = {
        checked: false,
        condition: { label: "Is", value: "is" },
        showInput: false,
        value: "",
      };
      return acc;
    }, {})
  );

  /* -------------------- FETCH DYNAMIC DATA -------------------- */
  
  // Fetch colours
  useEffect(() => {
    setColourLoading(true);
    dispatch(getColoursList())
      .finally(() => setColourLoading(false));
  }, [dispatch]);

  // Fetch material types
  useEffect(() => {
    setMaterialTypeLoading(true);
    dispatch(getRawMaterialCollectionList())
      .finally(() => setMaterialTypeLoading(false));
  }, [dispatch]);

  // Update colour options
  useEffect(() => {
    if (colourList && colourList.length > 0) {
      const options = colourList.map(colour => ({
        value: colour.ROWID,
        label: colour.colour
      }));
      setColourOptions(options);
    } else {
      setColourOptions([]);
    }
  }, [colourList]);

  // Update material type options - similar to form
  useEffect(() => {
    if (rawMaterialCollectionList && rawMaterialCollectionList.length > 0) {
      const options = rawMaterialCollectionList.map(item => ({
        value: item.rawMaterialCollection?.ROWID || item.ROWID,
        label: item.rawMaterialCollection?.materialType || item.materialType || item.name
      }));
      setMaterialTypeOptions(options);
    } else {
      setMaterialTypeOptions([]);
    }
  }, [rawMaterialCollectionList]);

  /* -------------------- HANDLERS -------------------- */

  const handleCheckboxChange = (key) => (e) => {
    const checked = e.target.checked;

    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        checked,
        condition: { label: "Is", value: "is" },
        showInput: checked,
        value: "",
      },
    }));
  };

  const handleConditionChange = (key) => (selected) => {
    const hideInputFor = ["is-empty", "is-not-empty"];

    setFilters((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        condition: selected,
        showInput: !hideInputFor.includes(selected.value),
      },
    }));
  };

  const handleValueChange = (key) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));
  };

  const getOptions = (key) => {
    switch (key) {
      case "materialType":
        return materialTypeOptions;
      case "tax":
        return taxOptions;
      case "colour":
        return colourOptions;
      case "consumptionUnit":
        return rawMaterialUnitOptions;
      default:
        return [];
    }
  };

  const getLoadingState = (key) => {
    switch (key) {
      case "colour":
        return colourLoading;
      case "materialType":
        return materialTypeLoading;
      default:
        return false;
    }
  };

  const getConditionOptions = (optionsType) => {
    switch (optionsType) {
      case "dropdown":
        return dropdownConditions;
      case "number":
        return numberComponent;
      default:
        return stringConditions;
    }
  };

  /* -------------------- SEARCH -------------------- */

  const handleSearch = async () => {
    const search = [];

    filtersConfig.forEach(({ key }) => {
      const current = filters[key];
      if (current.checked) {
        let value = current.value;
        let operation = current.condition?.value || "is";
        if (operation === "is-empty" || operation === "is-not-empty") value = "";

        const shouldAdd =
          operation === "is-empty" ||
          operation === "is-not-empty" ||
          (value !== undefined && value !== null && value !== "");

        if (shouldAdd) {
          search.push({ field: key, operation, value });
        }
      }
    });

    if (search.length === 0) {
      toast.warning("Please select at least one filter");
      return;
    }

    setShowProgressBar(true);

    try {
      const query = { page: "1", size: "100", search };
      
      sessionStorage.setItem("rawMaterialSearchQuery", JSON.stringify(query));
      
      const response = await dispatch(getRawMaterialList(query));
      
      setShowProgressBar(false);

      if (response?.error?.code === "ERR_BAD_REQUEST" || 
          response?.error?.message?.includes("404")) {
        toast.warning("No records found!");
        dispatch(setFilteredStatus(false));
      } else if (response?.payload?.success) {
        const data = response.payload?.data || [];
        
        if (data.length > 0) {
          setRecordCount && setRecordCount(data.length);
          dispatch(setFilteredStatus(true));
          toast.success("Raw materials filtered successfully!");
          closeDrawer();
        } else {
          toast.warning("No records found!");
          dispatch(setFilteredStatus(false));
          closeDrawer();
        }
      } else {
        toast.error("Error in filtering raw materials");
        dispatch(setFilteredStatus(false));
      }
    } catch (err) {
      setShowProgressBar(false);
      toast.error("Something went wrong");
      console.error("Search error:", err);
      dispatch(setFilteredStatus(false));
    }
  };

  /* -------------------- RESET -------------------- */

  const handleReset = () => {
    setFilters(
      filtersConfig.reduce((acc, f) => {
        acc[f.key] = {
          checked: false,
          condition: { label: "Is", value: "is" },
          showInput: false,
          value: "",
        };
        return acc;
      }, {})
    );
  };

  const handleOnClose = () => {
    handleReset();
    closeDrawer();
  };

  /* -------------------- UI -------------------- */

  return (
    <Drawer
      isOpen={isSearchDrawerOpen}
      placement="right"
      size="xs"
      onClose={handleOnClose}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerHeader>
          <div className="d-flex gap-4">
            <span>Search Raw Material</span>
            <button className="reset-btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </DrawerHeader>

        <DrawerBody>
          {showProgressBar && <ProgressBar colorScheme="pink" />}

          {filtersConfig.map(({ key, label, optionsType }) => {
            const current = filters[key];

            return (
              <div className="mt-3" key={key}>
                <Checkbox
                  isChecked={current.checked}
                  onChange={handleCheckboxChange(key)}
                >
                  {label}
                </Checkbox>

                {current.checked && (
                  <>
                    {/* Condition */}
                    <Select
                      className="mt-2"
                      options={getConditionOptions(optionsType)}
                      value={current.condition}
                      onChange={handleConditionChange(key)}
                    />

                    {/* Value */}
                    {current.showInput && (
                      <>
                        {optionsType === "dropdown" ? (
                          <Select
                            isClearable
                            className="mt-2"
                            options={getOptions(key)}
                            placeholder={`Select ${label}`}
                            isLoading={getLoadingState(key)}
                            onChange={(opt) =>
                              handleValueChange(key)(opt ? opt.value : "")
                            }
                            value={
                              getOptions(key).find(
                                (o) => o.value === current.value
                              ) || null
                            }
                          />
                        ) : (
                          <Input
                            className="mt-2"
                            type={
                              optionsType === "number" ? "number" : "text"
                            }
                            placeholder={`Enter ${label}`}
                            value={current.value || ""}
                            onChange={(e) =>
                              handleValueChange(key)(e.target.value)
                            }
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </DrawerBody>

        <center>
          <DrawerFooter style={{ display: "inline-block" }}>
            <div className="d-flex gap-3">
              <button className="cancel-button" onClick={handleOnClose}>
                Cancel
              </button>
              <button className="main-btn" onClick={handleSearch}>
                <span className="inner-content">Search</span>
              </button>
            </div>
          </DrawerFooter>
        </center>
      </DrawerContent>  
    </Drawer>
  );
}